<app-table [config]="tableConfig"/>
